/*
 * The order letter templates are offered in (KIN-1954).
 *
 * The list arrives in whatever order the endpoint returns, so ILH documents and everything else
 * come out interleaved and a doctor scrolls looking for the one they want. ILH documents go first
 * as a group, then the rest, each sorted by name.
 *
 * Grouping is read off the **name**, because that is the only thing available: `letter_template`
 * carries `id`, `name` and `template` and nothing else — no category or type column. If templates
 * ever gain a real category, this should read that instead of matching text.
 */
const ILH_PATTERN = /\bILH\b/i;

export const isIlhTemplate = (template) => ILH_PATTERN.test(template?.name ?? "");

const byName = (left, right) =>
  (left?.name ?? "").localeCompare(right?.name ?? "", undefined, {
    sensitivity: "base",
    numeric: true,
  });

export const sortLetterTemplates = (templates) =>
  [...(templates ?? [])].sort((left, right) => {
    const leftIsIlh = isIlhTemplate(left);
    const rightIsIlh = isIlhTemplate(right);

    if (leftIsIlh !== rightIsIlh) return leftIsIlh ? -1 : 1;

    return byName(left, right);
  });
